import React, { useEffect, useState } from "react";
import styles from "./DDPICompleted.module.scss";
import DoneImage from "../../../Components/assets/Images/congratsdoneimage.svg";
import { GetStatusDDPIAPICall } from "../DDPIAPICalls";

function DDPICompleted() {
  const [status, setStatus] = useState("");

  useEffect(() => {
    StatusDetails();
  }, []);

  const StatusDetails = () => {
    GetStatusDDPIAPICall()
      .then((response: any) => {
        // console.log("status", response.data.data);

        if (response.data.data.stage) {
          setStatus(response.data.data.stage);
        }
      })
      .catch((error: any) => {
        // console.log("error", error);
      });
  };
  return (
    <div className={styles.mainWrapperTop}>
      <div className={styles.wrapper}>
        <div className={styles.step}>
          <img src={DoneImage} />
        </div>
        <div className={styles.leftContainer}>
          <div className={styles.headerSection}>
            <p className={styles.signup}>
              {" "}
              {status === "approved"
                ? "Request Approved"
                : "Thanks For Submitting Request!"}
            </p>
            <div className={styles.textdiv}>
              <p className={styles.instructiontext}>
                {status === "approved"
                  ? "DDPI request has been Approved successfully."
                  : "DDPI request has been completed successfully. You will receive a confirmation email."}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DDPICompleted;
